// Типы для Phantom кошелька
interface PhantomWindow extends Window {
  solana?: {
    isPhantom?: boolean;
    connect: () => Promise<{ publicKey: { toString: () => string } }>;
    disconnect: () => Promise<void>;
    on: (event: string, callback: (args: any) => void) => void;
    signMessage: (message: Uint8Array, encoding: string) => Promise<{ signature: Uint8Array }>;
  };
}

declare const window: PhantomWindow;

// Класс для работы с Phantom кошельком
export class PhantomWallet {
  // Проверка наличия Phantom
  static isPhantomInstalled(): boolean {
    const phantom = (window as PhantomWindow).solana;
    return phantom && phantom.isPhantom ? true : false;
  }

  // Подключение к кошельку
  static async connect(): Promise<string | null> {
    try {
      if (!this.isPhantomInstalled()) {
        throw new Error('Phantom кошелек не установлен');
      }

      // Подключаемся к кошельку
      const phantom = (window as PhantomWindow).solana;
      const response = await phantom?.connect();
      
      // Получаем публичный ключ
      const publicKey = response?.publicKey.toString();
      
      // Сохраняем адрес в localStorage
      if (publicKey) {
        localStorage.setItem('walletAddress', publicKey);
        return publicKey;
      }
      
      return null;
    } catch (error) {
      console.error('Ошибка при подключении к Phantom:', error);
      return null;
    }
  }

  // Отключение от кошелька
  static async disconnect(): Promise<boolean> {
    try {
      if (!this.isPhantomInstalled()) {
        throw new Error('Phantom кошелек не установлен');
      }

      const phantom = (window as PhantomWindow).solana;
      await phantom?.disconnect();
      localStorage.removeItem('walletAddress');
      return true;
    } catch (error) {
      console.error('Ошибка при отключении от Phantom:', error);
      return false;
    }
  }

  // Получение текущего адреса кошелька
  static getCurrentWallet(): string | null {
    return localStorage.getItem('walletAddress');
  }

  // Проверка, подключен ли кошелек
  static isConnected(): boolean {
    return !!this.getCurrentWallet();
  }

  // Подписание сообщения (для аутентификации)
  static async signMessage(message: string): Promise<Uint8Array | null> {
    try {
      if (!this.isPhantomInstalled() || !this.isConnected()) {
        throw new Error('Phantom кошелек не установлен или не подключен');
      }

      const phantom = (window as PhantomWindow).solana;
      const encodedMessage = new TextEncoder().encode(message);
      const signedMessage = await phantom?.signMessage(encodedMessage, 'utf8');
      
      return signedMessage?.signature || null;
    } catch (error) {
      console.error('Ошибка при подписании сообщения:', error);
      return null;
    }
  }
} 